<template>
    <div>
        <div class="t-shops-settings">
            <div class="custom-checkbox">
                <the-btn
                    text="Zaznacz wszystkie"
                    class="btn-outline-custom d-none d-sm-inline-flex"
                    :class="{ 'd-inline-flex': !allowSelectAll }"
                    icon="CheckCorrect"
                    @click.native="selectAllMerchants(true)"
                />
                <the-btn
                    text="Odznacz wszystkie"
                    class="
                            btn-danger
                            ml-sm-2
                            d-none d-sm-inline-flex
                        "
                    :class="{ 'd-inline-flex': allowSelectAll }"
                    icon="CheckIncorrect"
                    @click.native="selectAllMerchants(false)"
                />
            </div>
        </div>
        <div class="t-shops scrollbar">
            <div class="scrollbar-shadow is-top"></div>
            <group-merchant
                v-for="merchant in merchants"
                :groupId="groupId"
                :key="merchant.id"
                :groupMerchant="merchant"
            />
            <div class="scrollbar-shadow is-bottom"></div>
        </div>
    </div>
</template>

<script>
import GroupMerchant from '@/components/promotions/GroupMerchant'

export default {
    props: {
        groupId: {
            type: Number,
            required: true
        }
    },
    components: {
        GroupMerchant
    },
    computed: {
        merchants() {
            return this.$store.getters.getSelectedPromoGroup(this.groupId)
                .merchantIds
        },
        allowSelectAll() {
            return this.merchants
                .filter(el => !el.disabled)
                .every(el => el.selected)
        }
    },
    methods: {
        selectAllMerchants(value) {
            this.$store.dispatch('selectGroupMerchants', {
                value,
                groupId: this.groupId
            })
        }
    }
}
</script>
